import axios from 'axios';
import path from 'path';
import socket from '../env/apiSocket';

function createApiMethod(apiPath) {
  return async function (params, field, cb) {
    if (_.isFunction(field)) {
      cb = field;
      field = undefined;
    }
    if (!_.isPlainObject(params)) {
      field = params;
      params = {};
    }

    const data = {
      access_token: (this.$store && this.$store.state && this.$store.state.access_token) || localStorage.getItem('token'),
      ...params,
    };

    if (typeof field !== 'undefined') data.data = field;

    console.log('success makeApiMethod', apiPath, data, !!cb);

    try {
      const response = await axios.post(config.apiAdminUrl + apiPath, data);
      const payload = response.data;
      if (_.isFunction(cb)) {
        if (payload.error) cb(payload.error, payload);
        else cb(null, payload);
      }

      return payload;
    } catch (e) {
      if (_.isFunction(cb)) cb(e);
      throw e;
    }
  };
}

function createSocketMethod(action) {
  /**
   * @param params {object}
   * @param params.customer_id {number}
   * @param params.access_token {string}
   */
  return async function (params, field, cb) {
    if (_.isFunction(field)) {
      cb = field;
      field = undefined;
    }

    const data = {
      access_token: params.access_token || localStorage.getItem('token'),
      ...params,
    };

    if (typeof field !== 'undefined') data.data = field;

    return new Promise((resolve, reject) => {
      console.log('SOCKET request api', action, data, !!cb);
      socket.emit(action, data, (err, result) => {
        console.log('SOCKET response', action, err, result);
        if (_.isFunction(cb)) cb(err, result);
        if (err) return reject(err);
        resolve(result);
      });
    });
  };
}

function makeAdminCategoryApi(relativePath) {
  const routePath = path.join('/category/', relativePath);
  return createApiMethod(routePath);
}

export {
  createApiMethod,
  createSocketMethod,
  makeAdminCategoryApi,
};



// WEBPACK FOOTER //
// ./src/lib/apiController.js